import { Study } from '../../../../shared/entities/scripts/study';
import { FormatDate, GetMonthFromNumber } from '../../../../shared/scripts/date-functions'
import { ComputePercent, FormatNumberWithCommas, Round_1Digit, Round_2Digits, Round_Number } from '../../../../shared/scripts/number-functions';

export class FinancialEntry {
    StudyName: string
    ProjectName: string
    EntryType: string

    FundedCommitmentAmount: number;
    InvoiceDateParsed: string;
    InvoiceNumber: string;
    InvoiceStatus: string;
    InvoicedAmount: number;
    InvoicedToDate: number;
    POEndDateParsed: string;
    POID: string;
    POReleaseNumber: string;
    ProjectLevel: string;
    ProjectNumber: string;
    RemainingCommitmentAmount: number;
    SubContractExcludeAmount: number;
    Subcontract: string;
    SubcontractCompanyName: string;
    SubcontractEndDateParsed: string;
    SubcontractStartDateParsed: string;
    SubcontractFundedAmount: number;
    SubcontractType: string;
    SubcontractSubcontractAmount: number;
    VendorName: string;
    VendorNumber: string;

    InvoiceDateCompare: Date;
    InvoiceDateDisplay: string;
    InvoicedToDateDisplay: string;
    POEndDateCompare: Date;
    POEndDateDisplay: string;
    SubcontractEndDateCompare: Date;
    SubcontractEndDateDisplay: string
    SubcontractStartDateCompare: Date;
    SubcontractStartDateDisplay: string

    FundedCommitmentAmountDisplay: string;
    InvoicedAmountDisplay: string;
    RemainingCommitmentAmountDisplay: string;
    SubcontractFundedAmountDisplay: string;
    SubContractExcludeAmountDisplay: string;
    SubcontractSubcontractAmountDisplay: string;

    StudyNameDisplay: string;
    ProjectNameDisplay: string;
    POIDDisplay: string;
    ProjectLevelDisplay: string;
    ProjectNumberDisplay: string;
    VendorNameDisplay: string;
    SubcontractDisplay: string;
    SubcontractCompanyNameDisplay: string;

    RestrictedFunds: number;
    RestrictedFundsDisplay: string;

    initialize(): void {

        // Format Invoice Date
        if (this.InvoiceDateParsed != "" && this.InvoiceDateParsed != null) {
            this.InvoiceDateCompare = new Date(this.InvoiceDateParsed);
            this.InvoiceDateDisplay = FormatDate(this.InvoiceDateCompare);
        }
        else {
            this.InvoiceDateCompare = null;
            this.InvoiceDateDisplay = "";
        }

        /*if (this.InvoiceStatus == "") {
            this.InvoiceStatus = "UNKNOWN";
        }*/

        // Format PO End Date
        if (this.POEndDateParsed != "" && this.POEndDateParsed != null) {
            this.POEndDateCompare = new Date(this.POEndDateParsed);
            this.POEndDateDisplay = FormatDate(this.POEndDateCompare);
        }
        else {
            this.POEndDateCompare = null;
            this.POEndDateDisplay = "";
        }

        // Format Subcontract End Date
        if (this.SubcontractEndDateParsed != "" && this.SubcontractEndDateParsed != null) {
            this.SubcontractEndDateCompare = new Date(this.SubcontractEndDateParsed);
            this.SubcontractEndDateDisplay = FormatDate(this.SubcontractEndDateCompare);
        }
        else {
            this.SubcontractEndDateCompare = null;
            this.SubcontractEndDateDisplay = "";
        }

        // Format Subcontract Start Date
        if (this.SubcontractStartDateParsed != "" && this.SubcontractStartDateParsed != null) {
            this.SubcontractStartDateCompare = new Date(this.SubcontractStartDateParsed);
            this.SubcontractStartDateDisplay = FormatDate(this.SubcontractStartDateCompare);
        }
        else {
            this.SubcontractStartDateCompare = null;
            this.SubcontractStartDateDisplay = "";
        }

        if (this.SubcontractSubcontractAmount != null && this.FundedCommitmentAmount != null) {
            this.RestrictedFunds = this.SubcontractSubcontractAmount - this.FundedCommitmentAmount;
        }
        else {
            this.RestrictedFunds = null;
        }

        // Format Currency
        this.FundedCommitmentAmountDisplay = this.displayCurrency(this.FundedCommitmentAmount);
        this.InvoicedAmountDisplay = this.displayCurrency(this.InvoicedAmount);
        this.InvoicedToDateDisplay = this.displayCurrency(this.InvoicedToDate);
        this.RemainingCommitmentAmountDisplay = this.displayCurrency(this.RemainingCommitmentAmount);
        this.SubcontractFundedAmountDisplay = this.displayCurrency(this.SubcontractFundedAmount);
        this.SubContractExcludeAmountDisplay = this.displayCurrency(this.SubContractExcludeAmount);
        this.SubcontractSubcontractAmountDisplay = this.displayCurrency(this.SubcontractSubcontractAmount);
        this.RestrictedFundsDisplay = this.displayCurrency(this.RestrictedFunds);

        // Links to Open Modal
        /*this.StudyNameDisplay = `<a class="study-modal modal-link">${this.StudyName}</a>`;
        this.ProjectNameDisplay = `<a class="project-name-modal modal-link">${this.ProjectName}</a>`;
        this.POIDDisplay = `<a class="poid-modal modal-link">${this.POID}</a>`;
        this.ProjectLevelDisplay = `<a class="project-level-modal modal-link">${this.ProjectLevel}</a>`;
        this.ProjectNumberDisplay = `<a class="project-number-modal modal-link">${this.ProjectNumber}</a>`;
        this.VendorNameDisplay = `<a class="vendor-name-modal modal-link">${this.VendorName}</a>`;
        this.SubcontractDisplay = `<a class="subcontract-modal modal-link">${this.Subcontract}</a>`;
        this.SubcontractCompanyNameDisplay = `<a class="subcontract-company-name-modal modal-link">${this.SubcontractCompanyName}</a>`;*/

        this.StudyNameDisplay = this.StudyName;
        this.ProjectNameDisplay = this.ProjectName;
        this.POIDDisplay = this.POID
        this.ProjectLevelDisplay = this.ProjectLevel;
        this.ProjectNumberDisplay = this.ProjectNumber;
        this.VendorNameDisplay = this.VendorName;
        this.SubcontractDisplay = this.Subcontract;
        this.SubcontractCompanyNameDisplay = this.SubcontractCompanyName;

    }

    displayCurrency(amount: number) {
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (amount == null || amount == undefined) {
            return ""
        }
        else if (amount >= 0) {
            return USDollar.format(amount);
        }
        else {
            return `<span class='negative-financial-value'>(${USDollar.format(Math.abs(amount))})</span>`
        }
       
    }
}

export class FinancialGraphData {
    Id: number;
    Name: string;
    DaysSinceLastInvoice: number;
    InvoicedToDate: number;
    RemainingUnrestricted: number;
    CommittedRestricted: number;
    DrillDown: FinancialGraphData[];

    StudyName: string;
    SubcontractNumber: string;
    POID: string;
    ProjectLevel: string;
    SubcontractStartDate: string;
    SubcontractEndDate: string;
    SubcontractType: string;

    TotalSubcontractAmount: number;
    TotalRestrictedFunds: number;
    TotalUnrestrictedFunds: number;
    RemainingUnrestrictedFunds: number;
    TotalInvoicedToDate: number;
    LastInvoiceDate: string;

    SortId: number;

    // Display Information
    StudyNameDisplay: string;
    VendorNameDisplay: string;
    TotalSubcontractAmountDisplay: string;
    TotalRestrictedFundsDisplay: string;
    TotalUnrestrictedFundsDisplay: string;
    RemainingUnrestrictedFundsDisplay: string;
    TotalInvoicedToDateDisplay: string;

    SubcontractStartDateCompare: string;
    SubcontractEndDateCompare: string;
    LastInvoiceDateCompare: string;

    initialize() {
        let sortArray = ["Infrastructure", "VITAL", "NEURO", "AUTONOMIC", "SLEEP", "ENERGIZE", "Committee Members", "Other CT ACC Subcontracts"];
        this.SortId = sortArray.indexOf(this.Name);
        this.InvoicedToDate = this.roundNumber(this.InvoicedToDate);
        this.RemainingUnrestricted = this.roundNumber(this.RemainingUnrestricted);
        this.CommittedRestricted = this.roundNumber(this.CommittedRestricted);

        this.StudyNameDisplay = `<a class="table-drilldown-btn font-weight-bold">${this.StudyName}</a>`;
        this.VendorNameDisplay = "";

        this.TotalSubcontractAmountDisplay = this.displayCurrency(this.TotalSubcontractAmount);
        this.TotalRestrictedFundsDisplay = this.displayCurrency(this.TotalRestrictedFunds);
        this.TotalUnrestrictedFundsDisplay = this.displayCurrency(this.TotalUnrestrictedFunds);
        this.RemainingUnrestrictedFundsDisplay = this.displayCurrency(this.RemainingUnrestrictedFunds);
        this.TotalInvoicedToDateDisplay = this.displayCurrency(this.TotalInvoicedToDate);

        this.SubcontractStartDateCompare = this.formatDateToCompare(new Date(this.SubcontractStartDate));
        this.SubcontractEndDateCompare = this.formatDateToCompare(new Date(this.SubcontractEndDate));
        this.LastInvoiceDateCompare = this.formatDateToCompare(new Date(this.LastInvoiceDate));

        this.DrillDown.forEach(entry => {
            entry.InvoicedToDate = this.roundNumber(entry.InvoicedToDate);
            entry.RemainingUnrestricted = this.roundNumber(entry.RemainingUnrestricted);
            entry.CommittedRestricted = this.roundNumber(entry.CommittedRestricted);

            //entry.StudyNameDisplay = `<a class="table-drillup-btn font-weight-bold"><span class="pr-2">${entry.StudyName}</span><i class="fas fa-undo"></i></a>`;
            entry.StudyNameDisplay = entry.StudyName;
            entry.VendorNameDisplay = entry.Name;
            if (entry.TotalSubcontractAmount != 0) {
                entry.TotalSubcontractAmountDisplay = this.displayCurrency(entry.TotalSubcontractAmount);
                entry.TotalRestrictedFundsDisplay = this.displayCurrency(entry.TotalRestrictedFunds);
                entry.TotalUnrestrictedFundsDisplay = this.displayCurrency(entry.TotalUnrestrictedFunds);
                entry.RemainingUnrestrictedFundsDisplay = this.displayCurrency(entry.RemainingUnrestrictedFunds);
            }
            else {
                entry.TotalSubcontractAmountDisplay = "";
                entry.TotalRestrictedFundsDisplay = "";
                entry.TotalUnrestrictedFundsDisplay = "";
                entry.RemainingUnrestrictedFundsDisplay = "";
            }
            
            entry.TotalInvoicedToDateDisplay = this.displayCurrency(entry.TotalInvoicedToDate);

            entry.SubcontractStartDateCompare = this.formatDateToCompare(new Date(entry.SubcontractStartDate));
            entry.SubcontractEndDateCompare = this.formatDateToCompare(new Date(entry.SubcontractEndDate));
            entry.LastInvoiceDateCompare = this.formatDateToCompare(new Date(entry.LastInvoiceDate));
            entry.SortId = sortArray.indexOf(entry.Name);
        });
    }

    roundNumber(amount: number): number {
        return Math.round((amount + Number.EPSILON) * 100) / 100;
    }

    displayCurrency(amount: number) : string {
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (amount == null || amount == undefined) {
            return ""
        }
        else if (amount >= 0) {
            return USDollar.format(amount);
        }
        else {
            return `<span class='negative-financial-value'>(${USDollar.format(Math.abs(amount))})</span>`
        }

    }

    formatDateToCompare(date: Date): string {
        if (date == null) return "";
        let months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
        let year = date.getFullYear();
        let month = months[date.getMonth()];
        let day = date.getDate().toString();
        if (day.length == 1) {
            day = "0" + day;
        }

        return `${year}${month}${day}`    
    }
}

export class VoucherEntry {
    // From API
    accounting_approve_dt: string; 
    acct: string; 
    acct_desc: string; 
    acct_entry_grp: string; 
    acct_function: string; 
    acct_type_desc: string; 
    active_fl: string; 
    amt: number; 
    auditorUserID: string;
    charge_fl: string; 
    company: string; 
    currency_rate_group: string; 
    due_dt: string; 
    emp_gems_id: string; 
    entr_dt: string; 
    entr_user_id: string;
    expensereport_name: string; 
    fiscal_pd: number; 
    fiscal_pd_sub: number; 
    fiscal_yr: string; 
    invc_id: string; 
    l1_acct_name: string; 
    l2_acct_name: string; 
    l3_acct_name: string; 
    org: string; 
    po_chng_ord_no: number; 
    po_id: string; 
    po_ln_no: number; 
    po_rlse_no: number; 
    post_dt: string; 
    proj: string; 
    reorg_lvl8: string; 
    source_id: string; 
    tc_fl: string; 
    terms_dc: string; 
    tran_currency: string; 
    tran_currency_dt: string; 
    trn_amt: number; 
    vendor: string; 
    vendor_name: string; 
    voucher_key: number; 
    voucher_ln_desc: string; 
    voucher_ln_key: number; 
    voucher_ln_no: number; 
    voucher_no: number; 
    voucher_type: string; 

    // Dates
    accounting_approve_dt_parsed: string;
    accounting_approve_dt_compare: Date;
    accounting_approve_dt_display: string;
    due_dt_parsed: string;
    due_dt_compare: Date;
    due_dt_display: string;
    entr_dt_parsed: string;
    entr_dt_compare: Date;
    entr_dt_display: string;
    post_dt_parsed: string;
    post_dt_compare: Date;
    post_dt_display: string;
    tran_currency_dt_parsed: string;
    tran_currency_dt_compare: Date;
    tran_currency_dt_display: string;
    fiscal_pd_display: string;

    // Currency
    amt_display: string;
    trn_amt_display: string;

    // Additional Fields
    project_name: string;
    study_name: string;

    initialize(): void {
        // Format Currency
        this.amt_display = this.displayCurrency(this.amt);
        this.trn_amt_display = this.displayCurrency(this.trn_amt);

        // Format Accounting Approve Date
        if (this.accounting_approve_dt_parsed != "" && this.accounting_approve_dt_parsed != null) {
            this.accounting_approve_dt_compare = new Date(this.accounting_approve_dt_parsed);
            this.accounting_approve_dt_display = FormatDate(this.accounting_approve_dt_compare);
        }
        else {
            this.accounting_approve_dt_compare = null;
            this.accounting_approve_dt_display = "";
        }

        // Format Due Date
        if (this.due_dt_parsed != "" && this.due_dt_parsed != null) {
            this.due_dt_compare = new Date(this.due_dt_parsed);
            this.due_dt_display = FormatDate(this.due_dt_compare);
        }
        else {
            this.due_dt_compare = null;
            this.due_dt_display = "";
        }

        // Format Entered Date
        if (this.entr_dt_parsed != "" && this.entr_dt_parsed != null) {
            this.entr_dt_compare = new Date(this.entr_dt_parsed);
            this.entr_dt_display = FormatDate(this.entr_dt_compare);
        }
        else {
            this.entr_dt_compare = null;
            this.entr_dt_display = "";
        }

        // Format Post Date
        if (this.post_dt_parsed != "" && this.post_dt_parsed != null) {
            this.post_dt_compare = new Date(this.post_dt_parsed);
            this.post_dt_display = FormatDate(this.post_dt_compare);
        }
        else {
            this.post_dt_compare = null;
            this.post_dt_display = "";
        }

        // Format Transaction Currency Date
        if (this.tran_currency_dt_parsed != "" && this.tran_currency_dt_parsed != null) {
            this.tran_currency_dt_compare = new Date(this.tran_currency_dt_parsed);
            this.tran_currency_dt_display = FormatDate(this.tran_currency_dt_compare);
        }
        else {
            this.tran_currency_dt_compare = null;
            this.tran_currency_dt_display = "";
        }

        // Format Fiscal Month
        if (this.fiscal_pd) {
            this.fiscal_pd_display = GetMonthFromNumber(this.fiscal_pd);
        }
        else {
            this.fiscal_pd_display = "";
            this.fiscal_pd = 0;
        }

        
    }

    displayCurrency(amount: number) {
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return USDollar.format(amount);
        }

    }
}

export class OverviewDataElement {
    StudyId: number;
    Enrollment: number[]; //current, target
    Invoiced: number[];
    Timeline: number[];
    EstimatedSpend: number[];

    Study: string;
    EnrollmentPercent: number;
    EnrollmentCountDisplay: string;
    InvoicedPercent: number;
    InvoicedCountDisplay: string;
    TimelinePercent: number;
    TimelineCountDisplay: string;
    EstimatedSpendCountDisplay: string;
    EstimatedSpendPercent: number;
    SortOrder: number;

    initialize(): void {
        this.SortOrder = this.StudyId;
        if (this.StudyId == 4) this.SortOrder = 5;
        if (this.StudyId == 5) this.SortOrder = 4;
        if (this.StudyId == 1) {
            this.EstimatedSpend[0] = this.Invoiced[0];
        }
        this.Study = Study.GetStudyName(this.StudyId);

        this.Invoiced[0] = Round_Number(this.Invoiced[0], 0);
        this.Invoiced[1] = Round_Number(this.Invoiced[1], 0);

        this.Timeline[0] = Round_Number(this.Timeline[0], 1);
        this.Timeline[1] = Round_Number(this.Timeline[1], 0);

        this.EnrollmentCountDisplay = FormatNumberWithCommas(this.Enrollment[0] + "") + " of " + FormatNumberWithCommas(this.Enrollment[1] + "");
        this.EnrollmentPercent = ComputePercent(this.Enrollment[0], this.Enrollment[1]) / 100.0;

        this.InvoicedCountDisplay = this.createMoneyDisplay(this.Invoiced[0]) + " of " + this.createMoneyDisplay(this.Invoiced[1]);
        this.InvoicedPercent = ComputePercent(this.Invoiced[0], this.Invoiced[1]) / 100.0;

        this.EstimatedSpendCountDisplay = this.createMoneyDisplay(this.EstimatedSpend[0]) + " of " + this.createMoneyDisplay(this.EstimatedSpend[1]);
        this.EstimatedSpendPercent = ComputePercent(this.EstimatedSpend[0], this.EstimatedSpend[1]) / 100.0;

        if (this.Timeline[1] != -1) {
            this.TimelineCountDisplay = FormatNumberWithCommas(this.Timeline[0] + "") + " of " + FormatNumberWithCommas(this.Timeline[1] + "");
            this.TimelinePercent = ComputePercent(this.Timeline[0], this.Timeline[1]) / 100.0;
        }
        else { this.TimelineCountDisplay = "No Invoices"; this.TimelinePercent = -1; }

        if (this.StudyId == 9 || this.StudyId == 1) {
            this.TimelineCountDisplay = `<span style="position:relative; left:50px;">Not Available</span>`;
            this.TimelinePercent = -1;
            if (this.StudyId == 1) {
                //this.EstimatedSpendPercent = -1;
                //this.EstimatedSpendCountDisplay = `<span style="position:relative; left:50px;">Not Available</span>`;
                this.EnrollmentPercent = -1;
                this.EnrollmentCountDisplay = `<span style="position:relative; left:50px;">Not Available</span>`;
            }
        }
    }

    createMoneyDisplay(amount: number): string {

        if (amount == 0) return "$0";
        else if (amount >= 100000) {
            return '$' + Round_Number((amount / 1000000), 2) + 'M'
        }
        else {
            return '$' + Round_Number(amount,2)
        }
    }
}